// Interface for all getters, mutations and actions

// Getters
export const GET_SETUP_ITEMS = 'setup/GET_SETUP_ITEMS';

// Mutations

// Actions
